export const normalizeId = (value: any): string => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string' || typeof value === 'number') return String(value);

  if (typeof value === 'object') {
    if (typeof value.$oid === 'string') return value.$oid;
    if (value._id !== undefined) return normalizeId(value._id);
    if (typeof value.id === 'string' || typeof value.id === 'number') return String(value.id);
    if (typeof value.toHexString === 'function') {
      const hex = value.toHexString();
      if (hex) return String(hex);
    }
  }

  if (typeof (value as any)?.toString === 'function') {
    const str = (value as any).toString();
    if (str && str !== '[object Object]') return str;
  }

  return '';
};
